import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FieldRadio from '../../components/FieldRadio/FieldRadio';

import './fieldset-true-false.scss';

const FieldSetTrueFalse = (props) => {
    const {
        form,
        id,
        field,
        label,
        options,
        assessmentLanguage,
    } = props;
    const fieldName = field.name;
    const fieldId = id || fieldName;
    const error = form.errors[fieldName];
    const isInvalid = error !== undefined && error !== null;
    const isTouched = !!form.touched[fieldName];
    const className = classNames('fieldset-true-false', {
        'fieldset-true-false--invalid': isTouched && isInvalid,
    });
    let or = 'OR';
    if (assessmentLanguage) {
        if (assessmentLanguage === 'SPA' || assessmentLanguage === 'LAS') {
            or = 'O';
        } else if (assessmentLanguage === 'FRE') {
            or = 'OU';
        } else if (assessmentLanguage === 'POR' || assessmentLanguage === 'POE') {
            or = 'OU';
        } else if (assessmentLanguage === 'CHI') {
            or = '或者';
        } else if (assessmentLanguage === 'CZE') {
            or = 'NEBO';
        } else if (assessmentLanguage === 'RUS') {
            or = 'ИЛИ';
        } else if (assessmentLanguage === 'GER') {
            or = 'ODER';
        } else if (assessmentLanguage === 'DUT') {
            or = 'Of..';
        } else if (assessmentLanguage === 'IND') {
            or = 'Atau';
        } else if (assessmentLanguage === 'DAN') {
            or = 'ELLER';
        } else if (assessmentLanguage === 'FIN') {
            or = 'TAI';
        } else if (assessmentLanguage === 'JPN') {
            or = 'または';
        } else if (assessmentLanguage === 'KOR') {
            or = '또는';
        }
    }

    return (
        <fieldset className={className} id={`fieldset-${fieldId}`} aria-required={isInvalid}>
            <legend className="fieldset-true-false__label">{label}</legend>
            {
                options.map((option, idx) => (
                    <React.Fragment
                        key={option.id}
                    >
                        {
                            idx === 1 ?
                                <span className="fieldset-true-false__separator">{or}</span>
                                :
                                null
                        }
                        {
                            idx !== 2 ?
                                <FieldRadio
                                    appearance="button"
                                    field={field}
                                    form={form}
                                    id={`${option.id}`}
                                    label={option.text}
                                    value={`${option.id}`}
                                />
                                :
                                null
                        }

                    </React.Fragment>
                ))
            }
        </fieldset>
    );
};

FieldSetTrueFalse.propTypes = {
    field: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.string,
    }).isRequired,
    form: PropTypes.shape({
        errors: PropTypes.objectOf(PropTypes.string),
        touched: PropTypes.objectOf(PropTypes.bool),
    }).isRequired,
    label: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    options: PropTypes.arrayOf(PropTypes.shape({})),
    assessmentLanguage: PropTypes.string.isRequired,
};

FieldSetTrueFalse.defaultProps = {
    id: '',
    options: [],
};

export default FieldSetTrueFalse;
